import { useContext } from 'react';

import HamburgerMenu from 'components/HamburgerMenu';
import HamburgerIcon from 'components/icons/HamburgerIcon';

import hamburgerContext from 'contexts/hamburger';

import data from './data';

import styles from './styles.module.scss';

const Hamburger = () => {
    const { isOpen, setIsOpen } = useContext(hamburgerContext);

    const handleClick = () => setIsOpen(!isOpen);

    return (
        <div className={styles.hamburger}>
            <HamburgerIcon
                className={styles.hamburgerIcon}
                isOpen={isOpen}
                onClick={handleClick}
            />

            <HamburgerMenu
                className={styles.hamburgerMenu}
                isOpen={isOpen}
                items={data}
                onItemClick={handleClick}
            />
        </div>
    );
};

export default Hamburger;
